import axios from "axios";
import React, { useEffect, useState } from "react";
import { AiFillLock, AiOutlineMail, AiOutlineUser } from "react-icons/ai";
import styled from "styled-components";
import { Logo } from "../../assets/svg/index";
import Footer from "../Footer/Footer";
import SplashScreen from "../utils/SplashScreen";
import { ensureDeviceToken } from "../utils/deviceToken";
import Toast from "../utils/Toast";

const Container = styled.div`
  padding: 1rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const LogoWrapper = styled.div`
  width: 150px;
  height: auto;
  margin:0 auto;

  @media (min-width: 61.313em) {
  margin:0;
  }
`;
const Main = styled.main`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Heading = styled.h1`
  margin: 1rem;
  font-family: "montserrat-semi-bold";
`;
const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #e0e8e6;
  padding: 0.6rem 1.1rem;
  margin: 1rem auto;
  border-radius: 10px;
  &:focus {
    border: 2px solid green;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 0.6rem;
  font-size: 1rem;
`;

const StyledBtn = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  color: white;
  background-color: #107066;
  padding: 0.6rem 1.3rem;
  border-radius: 20px;
  font-size: 1.2rem;
`;
const FooterWrapper = styled.div`
  margin-top: auto;
`;
const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: 61.313em) {
    width: 25%;
  }
`;
export default function Login() {
  const [Loading, setLoading] = useState(false);

  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [err, seterr] = useState("");
  const [conflictDevice, setConflictDevice] = useState(null);

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const loginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const deviceToken = ensureDeviceToken();


    try {

      // post email and password to server
      const res = await axios.post(`${process.env.REACT_APP_API}/user/login`, {
        ...user,
        deviceToken
      });

      if (res.status === 200) {
        // set token
        localStorage.setItem("accessToken", res.data.accesstoken);

        setLoading(false);
        window.location.reload();
      }
    } catch (err) {
      setLoading(false);
      setConflictDevice(null);
      if (err.response?.status === 409 && err.response?.data?.conflictDevice) {
        // Server found this user already has an active session on a different device.
        // Show the registered device details so the user understands what to do.
        const cd = err.response.data.conflictDevice;
        const lastUsed = cd.lastUsedAt
          ? new Date(cd.lastUsedAt).toLocaleString()
          : "unknown time";
        seterr(
          `Already logged in on: ${cd.model || "another device"} (last used: ${lastUsed}). Please use that device or contact your admin to clear the session.`
        );
        setConflictDevice(cd);
      } else if (err.response?.data?.message) {
        seterr(err.response.data.message);
      }
    }

  };

  useEffect(() => {
    // check if user is logged in
    const accessToken = localStorage.getItem("accessToken");

    // if user is logged in, redirect to home page
    if (accessToken) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, []);

  if (Loading) {
    return <SplashScreen />;
  }

  return (
    <Container>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>

      <Main>
        <Heading>Login.</Heading>
        <StyledForm onSubmit={loginSubmit}>
          <InputWrapper>
            <AiOutlineUser size={30} />
            <StyledInput
              type="text"
              name="email"
              required
              placeholder="Email or Phone Number"
              value={user.email}
              onChange={onChangeInput}
            />
          </InputWrapper>
          <InputWrapper>
            <AiFillLock size={30} />
            <StyledInput
              type="password"
              name="password"
              required
              autoComplete="on"
              placeholder="Password"
              value={user.password}
              onChange={onChangeInput}
            />
          </InputWrapper>
          <StyledBtn type="submit" value="Submit">
            Submit.
          </StyledBtn>
        </StyledForm>
        {err && (
          <Toast
            message={err}
            onClose={() => seterr("")}
          />
        )}
      </Main>

      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Container>
  );
}



// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { AiFillLock, AiOutlineMail } from "react-icons/ai";
// import styled from "styled-components";
// import { Logo } from "../../assets/svg/index";
// import Footer from "../Footer/Footer";
// import SplashScreen from "../utils/SplashScreen";
// import NativeHelper from "../utils/nativeUtils";

// const Container = styled.div`
//   padding: 1rem;
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
// `;

// const LogoWrapper = styled.div`
//   width: 150px;
//   height: auto;
//   margin:0 auto;

//   @media (min-width: 61.313em) {
//   margin:0;
//   }
// `;
// const Main = styled.main`
//   margin: auto 0;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
// `;
// const Heading = styled.h1`
//   margin: 1rem;
//   font-family: "montserrat-semi-bold";
// `;
// const InputWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
//   background-color: #e0e8e6;
//   padding: 0.6rem 1.1rem;
//   margin: 1rem auto;
//   border-radius: 10px;
//   &:focus {
//     border: 2px solid green;
//   }
// `;

// const StyledInput = styled.input`
//   width: 100%;
//   padding: 0.6rem;
//   font-size: 1rem;
// `;

// const StyledBtn = styled.button`
//   border: none;
//   outline: none;
//   cursor: pointer;
//   background-color: #ffd037;
//   padding: 0.6rem 1.3rem;
//   border-radius: 20px;
//   font-size: 1.2rem;
// `;
// const FooterWrapper = styled.div`
//   margin-top: auto;
// `;
// const ServerErr = styled.p`
//   margin: 1rem auto;
//   color: red;
// `;
// const StyledForm = styled.form`
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;

//   @media (min-width: 61.313em) {
//     width: 25%;
//   }
// `;
// export default function Login() {
//   const [Loading, setLoading] = useState(false);

//   const [user, setUser] = useState({
//     email: "",
//     password: "",
//   });
//   const [err, seterr] = useState("");

//   const onChangeInput = (e) => {
//     const { name, value } = e.target;
//     setUser({ ...user, [name]: value });
//   };

//   // const loginSubmit = async (e) => {
//   //   e.preventDefault();
//   //   setLoading(true);

//   //   try {
//   //     // ✅ Gather device info from frontend
//   //     const deviceInfo = {
//   //       device: navigator.platform, // e.g., "MacIntel", "Win32", "iPhone"
//   //       deviceType: /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
//   //       os: navigator.userAgentData?.platform || navigator.platform,
//   //       browser: navigator.userAgentData?.brands
//   //         ? navigator.userAgentData.brands.map(b => `${b.brand} ${b.version}`).join(", ")
//   //         : navigator.userAgent,
//   //     };

//   //     // post email, password, and device info to server
//   //     const res = await axios.post(`${process.env.REACT_APP_API}/user/login`, {
//   //       ...user,
//   //       mobileLogin: window && window?.flutter_inappwebview,
//   //       deviceInfo, // send device info
//   //     });

//   //     if (res.status === 200) {
//   //       // set token
//   //       localStorage.setItem("accessToken", res.data.accesstoken);
//   //       user?.email && NativeHelper.loginOneSignal(user.email);

//   //       setLoading(false);
//   //       window.location.reload();
//   //     }
//   //   } catch (err) {
//   //     setLoading(false);
//   //     // set error
//   //     err.response?.data?.message && seterr(err.response.data.message);
//   //   }
//   // };


//   const loginSubmit = async (e) => {
//   e.preventDefault();
//   setLoading(true);

//   try {
//     // ✅ Helper to get macOS version from userAgent
//     const getMacOSVersion = () => {
//       const ua = navigator.userAgent;
//       const macosMatch = ua.match(/Mac OS X (\d+[_\.]\d+[_\.]?\d*)/);
//       if (macosMatch && macosMatch[1]) {
//         return macosMatch[1].replace(/_/g, "."); // e.g., 12_7_6 → 12.7.6
//       }
//       return "Unknown";
//     };

//     // ✅ Helper to get iOS version from userAgent
//     const getIOSVersion = () => {
//       const ua = navigator.userAgent;
//       const iosMatch = ua.match(/OS (\d+[_\.]\d+[_\.]?\d*) like Mac OS X/);
//       if (iosMatch && iosMatch[1]) {
//         return iosMatch[1].replace(/_/g, "."); // e.g., 16_5_1 → 16.5.1
//       }
//       return "Unknown";
//     };

//     // ✅ Detect OS
//     let os = "Unknown";
//     if (/MacIntel/.test(navigator.platform)) {
//       os = `macOS ${getMacOSVersion()}`;
//     } else if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
//       os = `iOS ${getIOSVersion()}`;
//     } else if (/Win/.test(navigator.platform)) {
//       const winMatch = navigator.userAgent.match(/Windows NT (\d+\.\d+)/);
//       os = winMatch ? `Windows ${winMatch[1]}` : "Windows";
//     } else if (/Android/.test(navigator.userAgent)) {
//       const androidMatch = navigator.userAgent.match(/Android (\d+(\.\d+)?)/);
//       os = androidMatch ? `Android ${androidMatch[1]}` : "Android";
//     }

//     // ✅ Gather device info
//     const deviceInfo = {
//       device: navigator.platform,
//       deviceType: /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
//       os,
//       browser: navigator.userAgentData?.brands
//         ? navigator.userAgentData.brands.map(b => `${b.brand} ${b.version}`).join(", ")
//         : navigator.userAgent,
//     };

//     // post email, password, and device info to server
//     const res = await axios.post(`${process.env.REACT_APP_API}/user/login`, {
//       ...user,
//       mobileLogin: window && window?.flutter_inappwebview,
//       deviceInfo, // send device info
//     });

//     if (res.status === 200) {
//       localStorage.setItem("accessToken", res.data.accesstoken);
//       user?.email && NativeHelper.loginOneSignal(user.email);

//       setLoading(false);
//       window.location.reload();
//     }
//   } catch (err) {
//     setLoading(false);
//     err.response?.data?.message && seterr(err.response.data.message);
//   }
// };

//   useEffect(() => {
//     // check if user is logged in
//     const accessToken = localStorage.getItem("accessToken");

//     // if user is logged in, redirect to home page
//     if (accessToken) {
//       setLoading(true);
//     } else {
//       setLoading(false);
//     }
//   }, []);

//   if (Loading) {
//     return <SplashScreen />;
//   }

//   return (
//     <Container>
//       <LogoWrapper>
//         <Logo />
//       </LogoWrapper>

//       <Main>
//         <Heading>Login.</Heading>
//         <StyledForm onSubmit={loginSubmit}>
//           <InputWrapper>
//             <AiOutlineMail size={30} />
//             <StyledInput
//               type="email"
//               name="email"
//               required
//               placeholder="Email"
//               value={user.email}
//               onChange={onChangeInput}
//             />
//           </InputWrapper>
//           <InputWrapper>
//             <AiFillLock size={30} />
//             <StyledInput
//               type="password"
//               name="password"
//               required
//               autoComplete="on"
//               placeholder="Password"
//               value={user.password}
//               onChange={onChangeInput}
//             />
//           </InputWrapper>
//           <StyledBtn type="submit" value="Submit">
//             Submit.
//           </StyledBtn>
//         </StyledForm>
//         <ServerErr> {err}</ServerErr>
//       </Main>

//       <FooterWrapper>
//         <Footer />
//       </FooterWrapper>
//     </Container>
//   );
// }




